import React from 'react';
import { STooltip, SIcon } from '@avalara/skylab-sdk/react';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import { NON_ACTIONABLE_STATUSES } from '../../../utils/uploadedDocumentsHelper';

const ActionColumnCell = ({ document, statusKey, statusLabel, selected, onChange, hasChildRows, languages }) => {
    if (NON_ACTIONABLE_STATUSES.has(statusKey)) {
        return (
            <td className="checkbox-column" onClick={(e) => e.stopPropagation()}>
                <SIcon id={`action-info-${document.id}`} name="info-circle" style={{ cursor: 'pointer' }} />
                <STooltip triggerId={`action-info-${document.id}`} tooltipId={`action-tooltip-${document.id}`}>
                    <span slot="content">{LANGUAGES_CONTROLLER.format(languages, 'uploadedDocuments_nonActionableStatusTooltip', [statusLabel])}</span>
                </STooltip>
            </td>
        );
    }

    const checkboxId = `checkbox-${document.id}`;
    return (
        <td className="checkbox-column" onClick={(e) => e.stopPropagation()}>
            <div className="checkbox-wrapper">
                <input
                    type="checkbox"
                    checked={selected || false}
                    onChange={onChange}
                    disabled={false}
                    id={checkboxId}
                    data-parent={hasChildRows ? 'true' : 'false'}
                    data-document-id={document.id}
                />
                <label htmlFor={checkboxId}>&nbsp;</label>
            </div>
        </td>
    );
};


ActionColumnCell.defaultProps = {
    hasChildRows: false,
    languages: {}
};

export default ActionColumnCell;
